export default __webpack_public_path__ + "static/src/assets/images/icons/mobiles/myacc_icon_risklevel@3x.png";